import {Modal} from 'bootstrap/js/dist/modal';
window.Modal = Modal;
import {Dropdown} from 'bootstrap/js/dist/dropdown';
window.Dropdown = Dropdown;
import {Offcanvas} from 'bootstrap/js/dist/offcanvas';
window.Offcanvas = Offcanvas;

import WOW from 'wow.js';
window.WOW = WOW; // make it globally available for scripts.js

/*
import sidr from 'sidr/dist/sidr';
window.sidr = sidr;*/

import './scripts.js';

export default{
  Modal,
  Dropdown,
  Offcanvas,
}


